import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import React, { Dispatch, SetStateAction, useState } from "react";
import EventBus from "../../EventBus";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import { CustomSnackbarTypes } from "./CustomSnackBar";
import ChefForPartyService from "../../services/ChefForPartyService";
import VendorPayoutService from "../../services/VendorPayoutService";

interface InputProps {
  initiatedBy: any;
  open: boolean;
  data: any;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onSuccess?: () => Promise<void> | void;
}

const chefForPartyService = new ChefForPartyService();
const vendorPayoutService = new VendorPayoutService();

const UpdateCommentInChefForParty = (props: InputProps) => {
  const [comment, setComment] = useState<string>("");

  const handleClose = (e?: React.MouseEvent | React.SyntheticEvent) => {
    e?.stopPropagation();
    setComment("");
    props.setOpen(false);
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    e?.preventDefault();
    e?.stopPropagation();
    let payload = {
      comment: comment,
    };
    if (props.initiatedBy === 1) {
      chefForPartyService.updateAllocationComment(props?.data?.id, payload).then(() => {
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: "Successful",
          type: CustomSnackbarTypes.SUCCESS,
        });
        props.onSuccess?.();
        handleClose();
      });
    } else if (props.initiatedBy === 2) {
      chefForPartyService.updateSupplyComment(props?.data?.id, payload).then(() => {
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: "Successful",
          type: CustomSnackbarTypes.SUCCESS,
        });
        props.onSuccess?.();
        handleClose();
      });
    } else if (props.initiatedBy === 3) {
      chefForPartyService.updateCustomerComment(props?.data?.id, payload).then(() => {
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: "Successful",
          type: CustomSnackbarTypes.SUCCESS,
        });
        props.onSuccess?.();
        handleClose();
      });
    }
    else if (props.initiatedBy === 4) {
      let payload = {
        payoutComments: comment
      }
     vendorPayoutService.addPayoutComment(props?.data?.id, payload).then(() => {
      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        message: "Successful",
        type: CustomSnackbarTypes.SUCCESS,
      });
      props.onSuccess?.();
      handleClose();
     })
    }
  };

  return (
    <Dialog open={props.open} scroll={"paper"} onClick={(e) => e.stopPropagation()}>
      <DialogTitle>Update Comment</DialogTitle>
      <DialogContent>
        <TextField
          style={{ margin: "15px" }}
          label="Enter the Comment"
          value={comment}
          onChange={(event) => {
            setComment(event.target.value);
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color={"success"}
          onClick={() => {
            handleSubmit();
          }}
          size={"large"}
        >
          Submit
        </Button>
        <Button
          variant="contained"
          color={"error"}
          onClick={() => {
            props.setOpen(false);
            setComment("");
          }}
          size={"large"}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateCommentInChefForParty;
